<template lang="pug">
#invoices-view
  v-banner.d-block.d-md-none.title-banner(min-height="88")
    .text-h4.font-weight-bold {{ $t('Menu.__Sales') }} : {{ $t('Menu.__Invoice') }}
    template(v-slot:actions)
      v-menu(open-on-hover, offset-y)
        template(v-slot:activator="{ on }")
          v-btn.my-2.ml-4(rounded, dark, v-on="on", color="#b4b9be") 
            | {{ $t('ActionOption.__More') }}
            v-icon(right, dark) keyboard_arrow_down
        v-list
          template(v-for="item in moreActionItems")
            v-list-item(
              v-if="(invoice.status != 'Draft' && item.others == true) || (invoice.status == 'Draft' && item.draft == true)",
              @click="item.click()"
            )
              v-list-item-title {{ item.title }}
            v-divider(v-if="item.devider")

      v-btn.ml-6(rounded, dark, color="#b4b9be", @click="$router.push({ name: 'InvoiceNew' })") {{ $t('EstimatesAndInvoices.__CreateOtherInvoice') }}
  v-toolbar.d-md-block.d-none(elevation="2", height="88")
    v-toolbar-title.text-h4.font-weight-bold {{ $t('Menu.__Sales') }} : {{ $t('Menu.__Invoice') }}
    v-spacer
    v-menu(open-on-hover, offset-y)
      template(v-slot:activator="{ on }")
        v-btn.my-2.ml-4(rounded, dark, v-on="on", color="#b4b9be") 
          | {{ $t('ActionOption.__More') }}
          v-icon(right, dark) keyboard_arrow_down
      v-list
        template(v-for="item in moreActionItems")
          v-list-item(
            v-if="(invoice.status != 'Draft' && item.others == true) || (invoice.status == 'Draft' && item.draft == true)",
            @click="item.click()"
          )
            v-list-item-title {{ item.title }}
          v-divider(v-if="item.devider")

    v-btn.ml-6(rounded, dark, color="#b4b9be", @click="$router.push({ name: 'InvoiceNew' })") {{ $t('EstimatesAndInvoices.__CreateOtherInvoice') }}
  v-container
    ConfirmDialog(
      v-model="deleteDialog",
      :title="$t('EstimatesAndInvoices.__DeleteInvoice')",
      :message="$t('EstimatesAndInvoices.__ConfirmDeleteInvoice')",
      :cancel-text="$t('ActionOption.__Cancel')",
      :confirm-text="$t('ActionOption.__Delete')",
      :confirm-action="deleteInvoice"
    )
    SharedLinkDialog(
      v-model="sharedDialog",
      :link="sharedLink",
      :title="$t('EstimatesAndInvoices.__ShareInvoice')",
      :message="$t('EstimatesAndInvoices.__ShareInvoiceHint')",
      :confirmText="$t('EstimatesAndInvoices.__CopyLink')"
    )
    RecordInvoicePaymentDialog(
      v-model="recordPaymentDialog",
      :record-id="editedRecordId",
      :amount="invoice.unpaid",
      :invoice-id="id",
      :subtitle="$t('EstimatesAndInvoices.__No') + ' #' + invoice.number",
      :confirm-action="recordPaymentDone"
    )

    SendingEmailDialog(
      v-model="sendEmailDialog",
      :title="$t('EstimatesAndInvoices.__SendInvoice')",
      radioSubtitleKey="EstimatesAndInvoices.__SendInvoiceToCustomer",
      :customer="invoice.customer",
      category="invoice",
      :id="invoice.id"
    )
    SendingEmailDialog(
      v-model="sendReceiptDialog",
      :title="$t('EstimatesAndInvoices.__SendReceipt')",
      radioSubtitleKey="EstimatesAndInvoices.__SendInvoiceToCustomer",
      :customer="invoice.customer",
      category="receipt",
      :id="editedRecordId"
    )
    SendingEmailDialog(
      v-model="sendReminderDialog",
      :title="$t('EstimatesAndInvoices.__SendReminder')",
      radioSubtitleKey="EstimatesAndInvoices.__SendInvoiceToCustomer",
      :customer="invoice.customer",
      category="reminder",
      :id="invoice.id"
    )

    //- ConfirmDialog(v-model="sendReceiptDialog" :title="$t('EstimatesAndInvoices.__SendReceipt')" :message="$t('EstimatesAndInvoices.__SendReceiptHint',{ customer: invoice.customer.name })" :cancel-text="$t('ActionOption.__Cancel')" :confirm-text="$t('ActionOption.__Send')" :confirm-action="sendReceipt")
    //- ConfirmDialog(v-model="sendReminderDialog" :title="$t('EstimatesAndInvoices.__SendReminder')" :message="$t('EstimatesAndInvoices.__SendReminderHint',{ customer: invoice.customer.name })" :cancel-text="$t('ActionOption.__Cancel')" :confirm-text="$t('ActionOption.__Send')" :confirm-action="sendReminder")
    ConfirmDialog(
      v-model="deleteTransactionDialog",
      :title="$t('Transactions.__DeleteTransaction')",
      :message="$t('Transactions.__ConfirmDeleteTransaction')",
      :cancel-text="$t('ActionOption.__Cancel')",
      :confirm-text="$t('ActionOption.__Delete')",
      :confirm-action="deleteEditTransaction"
    )
    .invoice-info.d-md-flex.mb-5
      .invoice-status.mr-10.ma-2
        .field-label 
          span {{ $t('EstimatesAndInvoices.__Status') }}
        //- v-chip(color="success") 已儲存
        v-chip(dark, small, :color="getStatusColor(invoice.status)") {{ $t('Status.__' + invoice.status) }}
      .invoice-customer.mr-10.ma-2(v-if="invoice.customer")
        .field-label 
          span {{ $t('EstimatesAndInvoices.__Customer') }}
        | {{ invoice.customer.name }}
      .invoice-amount-due.mr-10.ma-2
        .field-label 
          span {{ $t('EstimatesAndInvoices.__OutstandingPayment') }}
        span(v-if="invoice.currencyCode") {{ getAmountWithCurrency(invoice.unpaid, invoice.currencyCode) }}
      .invoice-due-date.mr-10.ma-2
        .field-label 
          span {{ $t('EstimatesAndInvoices.__InvoiceDueOn') }}
        | {{ invoice.expiredAt }}
    Alert(permanent)
    v-row
      v-col.py-0(cols="12")
        v-card.mb-4
          v-card-text.invoice-view-card-text.d-md-flex.px-10
            .d-flex.mb-4.mb-md-0
              v-btn.mr-10(outlined, icon)
                v-icon.material-icons-outlined description
              .create-date.mr-10
                .field-label 
                  span {{ $t('EstimatesAndInvoices.__InvoiceDate') }}
                | {{ invoice.issuedAt }}
            .btn-set.ml-auto
              v-btn.ml-md-6(rounded, outlined, color="#505356", @click="edit") {{ $t('EstimatesAndInvoices.__EditInvoice') }}
              v-btn.ml-4(v-if="invoice.status == 'Draft'", rounded, outlined, color="#505356", @click="approve") {{ $t('EstimatesAndInvoices.__Approve') }}
        .approved-invoice(v-if="invoice.status != 'Draft'")
          .invoice-view-vertical-line
          v-card.mb-4
            v-card-text.invoice-view-card-text.d-md-flex.px-10
              .d-flex.mb-4.mb-md-0
                v-btn.mr-10(outlined, icon)
                  v-icon.material-icons-outlined send
                .d-block(style="width: inherit")
                  .d-md-flex
                    .create-date.mr-10
                      .field-label 
                        span {{ $t('EstimatesAndInvoices.__SendToCustomer') }}
                      //-     span {{$t('EstimatesAndInvoices.__SendingHistory')}}
                      //- .send-history {{$t('EstimatesAndInvoices.__NeverSent')}}
                      //- .customer-view-history 顧客最近一次於 2020/03/20 18:44 (GMT+8) 瀏覽
              .btn-set.ml-auto
                v-btn.ml-md-6(rounded, outlined, color="#505356", @click="shareLink") {{ $t('EstimatesAndInvoices.__GetLink') }}
                //- v-btn.ml-6(rounded outlined color="#505356") {{$t('EstimatesAndInvoices.__MarkAsSent')}}
                v-btn.ml-4(rounded, outlined, color="#505356", @click="sendEmail") {{ $t('EstimatesAndInvoices.__SendInvoice') }}
          .invoice-view-vertical-line
          v-card.mb-4
            v-card-text.invoice-view-card-text.d-md-flex.px-10
              v-btn.mr-10.d-none.d-md-block(outlined, icon)
                v-icon.material-icons-outlined credit_card
              .d-block(style="width: inherit")
                .d-md-flex
                  .d-flex.mb-4.mb-md-0
                    v-btn.mr-10.d-md-none(outlined, icon)
                      v-icon.material-icons-outlined credit_card
                    .mr-md-10
                      .field-label 
                        span {{ $t('EstimatesAndInvoices.__GetPaid') }}
                      div 
                        span {{ $t('EstimatesAndInvoices.__OutstandingPayment') }} {{ getAmountWithCurrency(invoice.unpaid, invoice.currencyCode) }}
                      //- span 
                      //-     a 記錄此款項
                      //- span 。目前已收到部分款項，
                      //-     a 寄送提醒給客戶
                  .btn-set.ml-auto
                    v-btn.ml-md-6(rounded, color="primary", @click="sendReminderDialog = true") {{ $t('EstimatesAndInvoices.__SendReminder') }}
                    v-btn.ml-4(rounded, color="primary", @click="editedRecordId = null; recordPaymentDialog = true") {{ $t('EstimatesAndInvoices.__RecordPaymentReceived') }}

                v-divider.my-4
                .d-flex.my-2(v-for="item in transactionRecords") 
                  div 
                    span.mr-4 {{ $t('EstimatesAndInvoices.__PaymentHistoryFormat', { date: item.date, paymentAmount: getAmountWithCurrency(item.amount, invoice.currencyCode) }) }}
                    span 
                      a(@click="sendReceiptDialog = true; editedRecordId = item.id") {{ $t('EstimatesAndInvoices.__SendReceipt') }}
                    span /
                    span 
                      a(@click="editedRecordId = item.id; recordPaymentDialog = true") {{ $t('EstimatesAndInvoices.__EditPayment') }}
                    span /
                    span 
                      a(@click="deleteTransactionDialog = true; editedRecordId = item.id") {{ $t('EstimatesAndInvoices.__DeletePayment') }}
      v-row
        v-col(cols="12")
          .pdf-container.pa-md-0.pa-3
            #pdf.pdf-view
              InvoiceViewPage(:data="invoice")
</template>
<script>
import InvoiceViewPage from "@/components/InvoiceViewPage"
import SharedLinkDialog from "@/components/dialogs/SharedLinkDialog"
import SendingEmailDialog from "@/components/dialogs/SendingEmailDialog"
import RecordInvoicePaymentDialog from "@/components/dialogs/RecordInvoicePaymentDialog"

import * as PDF from "@/utils/pdf"
import * as currencyHelper from "@/utils/currencies.js"

export default {
  mixins: [currencyHelper.mixin],

  components: {
    InvoiceViewPage,
    SharedLinkDialog,
    SendingEmailDialog,
    RecordInvoicePaymentDialog
  },
  data() {
    return {
      id: "",
      title: "銷售：請款單",
      sendReceiptDialog: false,
      deleteTransactionDialog: false,
      editedRecordId: "",
      sendReminderDialog: false,
      deleteDialog: false,
      sharedDialog: false,
      recordPaymentDialog: false,
      sharedLink: "",
      sendEmailDialog: false,
      statusItems: [
        {
          text: this.$t("Status.__Draft"),
          color: "#dcdcdc",
          key: "Draft"
        },
        {
          text: this.$t("Status.__Unsent"),
          color: "#505356",
          key: "Unsent"
        },
        {
          text: this.$t("Status.__Sent"),
          color: "#14c8c8",
          key: "Sent"
        },
        {
          text: this.$t("Status.__Partial"),
          color: "#b3e87f",
          key: "Partial"
        },
        {
          text: this.$t("Status.__Paid"),
          color: "#8cdc3c",
          key: "Paid"
        },
        {
          text: this.$t("Status.__Viewed"),
          color: "primary",
          key: "Viewed"
        },
        {
          text: this.$t("Status.__Expired"),
          color: "#e6465a",
          key: "Expired"
        }
      ],
      moreActionItems: [
        {
          title: this.$t("ActionOption.__Duplicate"),
          click: this.duplicateInvoice,
          draft: true,
          others: true
        },
        {
          title: this.$t("EstimatesAndInvoices.__Approve"),
          click: this.approve,
          draft: true,
          others: false
        },
        {
          title: this.$t("EstimatesAndInvoices.__RecordPaymentReceived"),
          click: () => {
            this.editedRecordId = null
            this.recordPaymentDialog = true
          },
          draft: false,
          others: true
        },
        {
          title: this.$t("EstimatesAndInvoices.__SendVia2SUMUP"),
          click: this.sendEmail,
          draft: false,
          others: true
        },
        {
          title: this.$t("EstimatesAndInvoices.__GetLink"),
          devider: true,
          click: this.shareLink,
          draft: false,
          others: true
        },
        {
          title: this.$t("ActionOption.__ExportPDF"),
          click: this.downloadPDF,
          draft: true,
          others: true
        },
        {
          title: this.$t("ActionOption.__Print"),
          devider: true,
          click: this.print,
          draft: true,
          others: true
        },
        {
          title: this.$t("EstimatesAndInvoices.__PreviewAsCustomer"),
          devider: true,
          click: this.customerView,
          draft: true,
          others: true
        },
        {
          title: this.$t("ActionOption.__Delete"),
          click: this.delete,
          draft: true,
          others: true
        }
      ],
      // dueNoticeItems: [{ text: "不用提醒" }, { text: "14天提醒" }],
      invoice: {
        status: "Draft",
        customer: { name: "" }
      },
      transactionRecords: []
      // company: {}
    }
  },
  methods: {
    getInvoice(id) {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("invoices/getInvoice", id)
        .then(
          function(response) {
            this.invoice = response.data

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    getTransactionRecords(id) {
      this.$store
        .dispatch("transactions/getInvoiceTransactionRecords", id)
        .then(
          function(response) {
            this.transactionRecords = response.data

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    customerView() {
      this.$router.push({
        name: "InvoiceCustomerView",
        params: {
          id: this.id
        }
      })
    },
    print() {
      this.$router.push({
        name: "InvoiceExport",
        params: {
          invoiceId: this.id,
          exportType: "print"
        }
      })
    },
    approve() {
      this.$store
        .dispatch("invoices/approveInvoice", this.id)
        .then(
          function(response) {
            this.$store.dispatch("global/stopLoading")
            this.getInvoice(this.id)
            // this.$store.dispatch(
            //     "global/showAlertSuccess",
            //     "已核准請款成功"
            // )
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    edit() {
      this.$router.push({
        name: "InvoiceEdit",
        params: {
          id: this.id
        }
      })
    },
    sendEmail() {
      this.sendEmailDialog = true
    },
    shareLink() {
      this.$store
        .dispatch("invoices/shareInvoice", this.id)
        .then(
          function(response) {
            var token = response.data.token
            this.sharedLink = process.env.VUE_APP_DOMAIN + "share/invoices/" + token

            this.sharedDialog = true

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    duplicateInvoice() {
      this.$store
        .dispatch("invoices/duplicateInvoice", this.id)
        .then(
          function(response) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDuplicated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    downloadPDF() {
      PDF.download("#invoice-preview-page", this.invoice.name + "_" + this.invoice.number, () => {})
    },

    delete() {
      this.deleteDialog = true
    },
    deleteInvoice() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("invoices/deleteInvoice", this.id)
        .then(
          function(response) {
            this.$store.dispatch("global/stopLoading")
            this.$router.push({
              name: "Invoices",
              params: {
                alert: {
                  message: this.$t("Messages.__SuccessfullyDeleted"),
                  type: "success"
                }
              }
            })
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
      this.deleteDialog = false
    },
    recordPaymentDone() {
      this.getInvoice(this.id)
      this.getTransactionRecords(this.id)
      this.$store.dispatch("global/stopLoading")
    },
    // sendReceipt() {
    //     this.$store
    //         .dispatch("transactions/sendReceipt", {
    //             id: this.editedRecordId
    //         })
    //         .then(
    //             function(response) {
    //                 this.$store.dispatch("global/stopLoading")
    //                 this.$store.dispatch(
    //                     "global/showAlertSuccess",
    //                     this.$t("Messages.__SuccessfullySend")
    //                 )
    //             }.bind(this)
    //         )
    //         .catch(
    //             function(error) {
    //                 this.$store.dispatch(
    //                     "global/showAlertError",
    //                     error.message
    //                 )
    //             }.bind(this)
    //         )
    // },
    // sendReminder() {
    //     this.$store
    //         .dispatch("invoices/sendInvoiceReminder", {
    //             id: this.id
    //         })
    //         .then(
    //             function(response) {
    //                 this.$store.dispatch("global/stopLoading")
    //                 this.$store.dispatch(
    //                     "global/showAlertSuccess",
    //                     this.$t("Messages.__SuccessfullySend")
    //                 )
    //             }.bind(this)
    //         )
    //         .catch(
    //             function(error) {
    //                 this.$store.dispatch(
    //                     "global/showAlertError",
    //                     error.message
    //                 )
    //             }.bind(this)
    //         )
    // },
    deleteEditTransaction() {
      this.$store
        .dispatch("transactions/deleteTransaction", this.editedRecordId)
        .then(
          function(response) {
            this.getInvoice(this.id)
            this.getTransactionRecords(this.id)
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDeleted"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    getStatusColor(status) {
      for (var item of this.statusItems) {
        if (item.key == status) {
          return item.color
        }
      }
    }
  },
  mounted() {},
  created() {
    // this.company = this.$store.getters["bizes/biz"]()
    this.id = this.$route.params.id
    this.getInvoice(this.id)
    this.getTransactionRecords(this.id)
  }
}
</script>
<style lang="scss" scoped>
.invoice-info {
  .invoice-customer {
    font-size: 23px;
    font-weight: bold;
    color: #e65c17;
  }
  .invoice-amount-due,
  .invoice-due-date {
    font-size: 23px;
    font-weight: bold;
    color: #505356;
  }
}

.invoice-view-card-text {
  font-size: 16px;
}

.invoice-view-vertical-line {
  margin: -15px 0 0 39px;
  border: 2px solid #b2c2cd;
  height: 18px;
  width: 0;
}
</style>
